<template>
  <b-container class="mt-3">
    <b-card class="tinyCard mt-4 mb-4" :body-class="isMobile ? 'p-2' : ''">
      <standard-table ref="enumConfig"
                      :items="items"
                      :search-id="'enum-search'"
                      :fields="getStaticOptions()"
                      :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"

                      :row-before-search="{cols: 12,sm: 12,md: 12,lg: 6,xl: 6,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                      :row-search="{cols: 12,sm: 12,md: 12,lg: 6,xl: 6,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 6, xl: 6}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 1}"
                      :row-per-page="{cols: 12, sm: 12, md: 3, lg: 3, xl: 3}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 2, lg: 2, xl: 2}"

                      :search-label-horizontal="false"
                      @rowEdit="showEditModal($event.item)"
                      @rowDelete="selected = $event.item; $refs.serviceDelete.show()"
                      fullWidth="true"
                      noContainerPadding="true">
        <b-container slot="row-before-search" class="mw-100 p-0">
          <b-row align-h="end">
            <b-col class="mb-3" cols="auto">
              <!-- config[crud], create - read - update - delete -->
              <b-button class="b-c-blue" id="add-enum" v-on:click="showEditModal()">{{$t('message.add')}}</b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container :body-class="isMobile ? 'p-2' : ''" slot="row-after-per-page" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0"
                        id="excel-button"
                        @click="$refs.enumConfig.excel(filename, getExcelFields())">Excel
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>
    </b-card>

    <b-modal ref="editModal" id="editModal" hide-footer
             :title="enumeration.id
             ? `${$t('message.edit')} ${$t('message.item').toLowerCase()}`
             : `${$t('message.add')} ${$t('message.item').toLowerCase()}`">
      <validation-observer ref="mainForm" v-slot="{ invalid }">
        <b-container>
          <b-row>
            <b-col>
              <validation-provider :name="$tc('message.description', 1).toLowerCase()"
                                   :rules="{ min: 0, max: 50, required: true }"
                                   v-slot="{ valid, errors }">
                <b-form-group :label="`${$tc('message.description', 1)} (*)`"
                              label-for="input-description">
                  <b-form-input v-model="enumeration.descrizione"
                                :state="itemChanged ? valid : null"
                                id="input-description"
                                type="text">
                  </b-form-input>

                  <div v-if="itemChanged && !valid" class="my-invalid-feedback"> <h6>{{ first(errors) }}</h6></div>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row class="my-border-top">
            <b-col class="mt-3 justify-content-end d-flex">
              <!-- config[crud], create - read - update - delete -->
              <b-button class="b-c-green mr-2" id="save-and-close"
                        v-on:click="saveAndClose" :disabled="!enumeration.descrizione || !itemChanged || invalid">{{$t('message.saveClose')}}</b-button>

              <b-button class="b-c-green" id="close" v-on:click="pushBack()">{{$t('message.close')}}</b-button>
            </b-col>
          </b-row>
        </b-container>
      </validation-observer>
    </b-modal>
    <b-modal ref="serviceDelete" id="serviceDelete" :title="`${$t('message.caution')}!`">
      <b-container>
        <h5>{{ $t('message.deleteCheck') }}?</h5>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <!-- config[crud], create - read - update - delete -->
        <b-button id="nw-delete-continue" class="m-1 b-c-green"
                   @click="deleteSelected()">{{ $t('message.saveClose') }}
        </b-button>

        <b-button id="nw-delete-close" class="m-1 b-c-green" @click="$refs.serviceDelete.hide()">
          {{ $t('message.close') }}
        </b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { cloneDeep, first } from 'lodash'
import Vue from 'vue'
import axios from 'axios'

export default {
  name: 'MotivationsRegistry',
  data () {
    const BASE_URL_PENALTY_CHARGE_NOTICE = Vue.getBaseUrlPenaltyChargeNotice()

    return {
      BASE_URL_PENALTY_CHARGE_NOTICE,
      isMobile: false,
      first,
      fields: [],
      enumeration: { descrizione: null },
      items: [],
      itemChanged: false,
      watcher: null,
      recipientOptions: [],
      selected: null,
      filename: 'Motivazioni'
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const config = {
        method: 'get',
        url: this.BASE_URL_PENALTY_CHARGE_NOTICE + '/motivazione-infrazione',
        headers: {
          Authorization: 'Bearer ' + token
        }
      }

      return axios(config).then((response) => {
        this.items = response.data.risorse
      }).catch(error => {
        Vue.manageErrors(this, error)
        return []
      })
    },
    saveAndClose () {
      const hasId = !!this.enumeration.id
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const url = hasId ? this.BASE_URL_PENALTY_CHARGE_NOTICE + '/motivazione-infrazione/' + this.enumeration.id : this.BASE_URL_PENALTY_CHARGE_NOTICE + '/motivazione-infrazione'
      const config = {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }
      if (!hasId) {
        return axios.post(url, this.enumeration, config).then((response) => {
          this.itemChanged = false
          this.pushBack()
          Vue.success(this, `${this.$tc('message.edit')} ${this.$tc('message.done', 2).toLowerCase()}`)
          this.$router.push({ name: 'RefreshPage', params: { redirect: '/motivations_registry' } })
        }).catch(error => {
          Vue.manageErrors(this, error)
        })
      } else {
        return axios.patch(url, this.enumeration, config).then((response) => {
          this.itemChanged = false
          this.pushBack()
          Vue.success(this, `${this.$tc('message.edit')} ${this.$tc('message.done', 2).toLowerCase()}`)
          this.$router.push({ name: 'RefreshPage', params: { redirect: '/motivations_registry' } })
        }).catch(error => {
          console.log(error)
          Vue.manageErrors(this, error)
        })
      }
    },
    getStaticOptions () {
      const fields = [
        // config[crud], create - read - update - delete
        { key: 'edit', label: '' },
        { key: 'delete', label: '' },
        { key: 'descrizione', label: `${this.$t('message.description')}`, sortable: true, sortDirection: 'desc' },
        { key: 'reminderGroupDescr', label: `${this.$tc('message.reminderGroup', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: !this.specialEnum, hideInExcel: !this.specialEnum },
        { key: 'notificationRecipientDescr', label: `${this.$tc('message.notificationGroup', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: !this.specialEnum, hideInExcel: !this.specialEnum },
        { key: 'reminderGroupMail', label: `${this.$tc('message.reminderGroup', 1)} ${this.$tc('message.email', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: true, hideInExcel: true },
        { key: 'notificationRecipientMail', label: `${this.$tc('message.notificationGroup', 1)} ${this.$tc('message.email', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: true, hideInExcel: true }
      ]
      this.fields = fields
      return fields
    },
    checkWatcher () {
      if (this.watcher) {
        this.watcher()
      }
      this.itemChanged = false
    },
    addWatcher () {
      this.watcher = this.$watch('enumeration', () => {
        this.itemChanged = true
      }, { deep: true })
    },
    showEditModal (item) {
      this.checkWatcher()
      this.$refs.editModal.show()
      if (item) {
        this.enumeration = cloneDeep(item)
      } else {
        this.enumeration = { decrizione: null }
      }
      this.addWatcher()
    },
    deleteSelected () {
      const session = Vue.getLocalStorage('session')
      const token = session && session.token
      const config = {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }

      return axios.delete(`${this.BASE_URL_PENALTY_CHARGE_NOTICE}/motivazione-infrazione/${this.selected.id}`, config)
        .then(() => {
          Vue.success(this, `${this.$tc('message.deleting')} ${this.$tc('message.done', 2).toLowerCase()}`)
          this.pushBack()
          this.$router.push({ name: 'RefreshPage', params: { redirect: '/motivations_registry' } })
          this.$root.$emit('activeLoader', false)
        }).catch(error => {
          Vue.manageErrors(this, error, Vue.getViolazioniHttpCode())
        })
    },
    pushBack () {
      this.$refs.editModal.hide('button')
      this.$refs.serviceDelete.hide()
      this.enumeration = { descrizione: null }
    },
    getExcelFields () {
      const fields = [
        // config[crud], create - read - update - delete
        { key: 'edit', label: '' },
        { key: 'delete', label: '' },
        { key: 'descrizione', label: `${this.$t('message.description')}`, sortable: true, sortDirection: 'desc' }
      ]
      return fields
    }
  }
}
</script>

<style scoped>

</style>
